import { cn } from '@/lib/utils';
import { icons } from 'lucide-react';

interface MetricCardProps {
  name: string;
  value: string | number;
  icon: keyof typeof icons;
  trend?: 'up' | 'down' | 'flat';
  filter?: 'day' | 'week' | 'month' | 'year';
  trendValue?: string | number;
  variant?: 'primary' | 'blue' | 'amber' | 'purple';
  className?: string;
}

function MetricCard({
  name,
  value,
  icon,
  trend = 'up',
  trendValue,
  variant = 'primary',
  className,
}: MetricCardProps) {
  const Icon = icons[icon];

  return (
    <div
      className={cn(
        'flex flex-col justify-between h-32 w-full max-w-2xl rounded-md p-4 bg-green-100/70 border border-border/40',
        className,
        { 'bg-blue-100/60': variant === 'blue' },
        { 'bg-amber-50': variant === 'amber' },
        { 'bg-purple-100/60': variant === 'purple' }
      )}
    >
      <div className="flex justify-between">
        <h5 className="text-sm">{name}</h5>
        <div className="w-10 h-10 bg-white rounded-full shrink-0 flex items-center justify-center">
          <Icon
            className={cn(
              'w-5 h-5 text-primary',
              { 'text-blue-500': variant === 'blue' },
              { 'text-amber-500': variant === 'amber' },
              { 'text-purple-500': variant === 'purple' }
            )}
          />
        </div>
      </div>
      <p className="font-semibold text-xl md:text-2xl">{value}</p>
      {trend && trendValue && (
        <></>
        // <Paragraph
        //   size="xs"
        //   className={cn('text-primary', {
        //     'text-destructive': trend === 'down',
        //     'text-muted-foreground': trend === 'flat',
        //   })}
        // >
        //   {/* {trend === 'down' ? '▼' : '▲'} */}
        //   {trend === 'down' && '-'}
        //   {trendValue} from last {filter}
        // </Paragraph>
      )}
    </div>
  );
}

export { MetricCard };
